export default function sendToken(context:any) {
    context.next();
}